<template>
    <div>
        <div class="mainWrapper">
            <MainSideBarVue />

            <div class="rightContentWrapper">
                <div class="topNav">
                    <TopBarVue />
                </div>

                <div class="innerContainer">




                    <div class="theHeaderWrapper">



                        <i @click="$router.go(-1)" style="font-size: 25px; font-weight: bold; cursor: pointer;"
                            class="bi bi-arrow-left"></i>

                        <div style="margin-left: 20px;">
                            Group Talk - {{ groupTalkStore.groupTalkPost.post ? groupTalkStore.groupTalkPost.post.title
                                : '' }}
                        </div>

                        <div class="methodType" v-if="groupTalkStore.groupTalkPost.completion_type === 'checkoff'">
                            <span class="badge bg-secondary">Checkoff</span>
                        </div>

                        <div class="methodType" v-if="groupTalkStore.groupTalkPost.completion_type === 'signature'">
                            <span class="badge bg-secondary">Signatures</span>
                        </div>

                        <div class="methodType" v-if="groupTalkStore.groupTalkPost.completion_type === 'signed_sheet'">
                            <span class="badge bg-secondary"> Sign-in Sheet</span>
                        </div>






                    </div>



                    <div class="searchBarWrapper" v-if="groupTalkStore.groupTalkPost.completion_type !== 'signed_sheet'">

                        <input v-model="searchQuery" type="text" class="form-control theBar"
                            placeholder="Search by employee name..." />

                        <div v-if="groupTalkStore.groupTalkPost.completion_type !== 'signed_sheet'" style="display: flex;">

                            <button @click="groupTalkStore.exportDataAsExcel(props.uuid)" class="button-13" style="margin-right: 8px;">Export as
                                Excel</button>


                            <div v-if="groupTalkStore.isDownloadingPDFsignatures">

                                <button class="button-13" style="padding-top: 5px; padding-bottom: 5px;"
                                >
                                    Exporting...
                                </button>

                            </div>

                             <div v-else>

                                <button class="button-13" v-if="groupTalkStore.groupTalkPost.completion_type === 'signature'"
                                @click="groupTalkStore.downloadThisGroupTalkSignaturesList()" 
                                style="padding-top: 5px; padding-bottom: 5px;"
                                >
                                    Export as PDF
                                </button>

                            </div>


                         

                        </div>




                    </div>

                    <div class="searchBarWrapper" v-if="groupTalkStore.groupTalkPost.completion_type === 'signed_sheet'">

                        <div>

                        </div>

                        <div>
                            <button @click="groupTalkStore.downloadImageFileInViewAttendees"
                                class="button-13">Download</button>
                        </div>


                    </div>



                    <div class="theSheetImgBox" v-if="groupTalkStore.groupTalkPost.completion_type === 'signed_sheet'">


                        <img class="theSheetImg" :src="groupTalkStore.groupTalkPost.sign_in_sheet_img_url">


                    </div>


                    <div v-else class="tableWrapper">

                        <table class="table table-hover my-custom-table">
                            <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Attended</th>
                                    <th v-if="groupTalkStore.groupTalkPost.completion_type === 'signature'" scope="col">
                                        Signature</th>

                                </tr>
                            </thead>

                            <tbody>

                                <tr v-for="(groupTalkAcknowledgement, index) in filteredAck" :key="index">


                                    <td>
                                        {{ groupTalkAcknowledgement.user ? groupTalkAcknowledgement.user.name : 'N/A' }}
                                    </td>

                                    <td>



                                        <div v-if="groupTalkAcknowledgement.is_acknowledged == 1">

                                            <span class="badge rounded-pill bg-success" style="font-size: 12px;">YES</span>

                                        </div>

                                        <div v-else>

                                            <span class="badge rounded-pill bg-danger" style="font-size: 12px;">NO</span>

                                        </div>


                                    </td>

                                    <td v-if="groupTalkStore.groupTalkPost.completion_type === 'signature'">

                                        <div class="theImgWrapper" v-if="groupTalkAcknowledgement.signature_img_url"
                                            @click="groupTalkStore.downloadImageFile(groupTalkAcknowledgement)">


                                            <img :src="groupTalkAcknowledgement.signature_img_url" class="imgSignature">



                                        </div>


                                        <div class="theImgWrapper" v-else>


                                            <div
                                                style="display: flex; justify-content: center; align-items: center; font-size: 11px; height: 100%; text-align: center;">
                                                No signature collected
                                            </div>


                                        </div>



                                    </td>



                                </tr>

                            </tbody>




                        </table>



                        <button v-if="displayedAckCount < groupTalkStore.groupTalkAcknowledgements.length"
                            class="btn btn-dark loadMoreBtn" @click="loadMoreAck">Load more</button>



                    </div>




                </div>
            </div>
        </div>





    </div>
</template>

<script setup>
import MainSideBarVue from "@/components/MainSideBar";
import TopBarVue from "@/components/TopBar.vue";
import { onMounted, defineProps, ref, computed } from 'vue';
import { useGroupTalkStore } from '@/stores/GroupTalkStore';


const groupTalkStore = useGroupTalkStore();

const props = defineProps({
    uuid: String,
})


const searchQuery = ref('');

const displayedAckCount = ref(25); // Start with displaying 5 teams
const incrementStep = 15; //


const filteredAck = computed(() => {

    return groupTalkStore.groupTalkAcknowledgements
        .filter(ack => ack.user.name.toLowerCase().includes(searchQuery.value.toLowerCase()))
        .slice(0, displayedAckCount.value);

});

const loadMoreAck = () => {
    displayedAckCount.value += incrementStep;
};



onMounted(() => {

    groupTalkStore.fetchAcknowledgmentData(props.uuid)

})



</script>

<style scoped>
.mainWrapper {
    /* background-color: aliceblue; */
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.rightContentWrapper {
    /* overflow-y: auto; */
    width: 83%;
    display: flex;
    flex-direction: column;
}

.contentContainer {
    /* overflow-y: auto; */
    background-color: rgb(208, 28, 55);
    /* margin: 30px; */
    margin-top: 100px;
}

.rightColumns {
    /* display: flex;
  flex-direction: column; */
}

.topNav {
    background-color: blue;
}

.innerContainer {
    /* margin-top: 200px; */
    /* background-color: blueviolet; */
    overflow-y: auto;
    padding-top: 30px;
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 100px;
}

.theHeaderWrapper {
    display: flex;
    align-items: center;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    /* background-color: aqua; */
}

.searchBarWrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    width: 100%;
    padding-bottom: 20px;
    /* background-color: rgb(22, 166, 37); */
}

.theBar {
    width: 350px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 10px;
}

.button-6 {
    align-items: center;
    /* background-color: #FFFFFF; */
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0.25rem;
    box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.85);
    cursor: pointer;
    display: inline-flex;
    font-family: system-ui, -apple-system, system-ui, "Helvetica Neue", Helvetica,
        Arial, sans-serif;
    font-size: 16px;
    font-weight: 600;
    justify-content: center;
    line-height: 1.25;
    margin: 0;
    min-height: 3rem;
    padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
    position: relative;
    text-decoration: none;
    transition: all 250ms;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    vertical-align: baseline;
    width: auto;
}

.button-6:hover,
.button-6:focus {
    border-color: rgba(0, 0, 0, 0.15);
    box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
    color: rgba(0, 0, 0, 0.65);
}

.button-6:hover {
    transform: translateY(-1px);
}

.button-6:active {
    background-color: #f0f0f1;
    border-color: rgba(0, 0, 0, 0.15);
    box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
    color: rgba(0, 0, 0, 0.65);
    transform: translateY(0);
}

.tableWrapper {
    margin-top: 20px;
    /* background-color: aqua; */
    width: 100%;
}

.my-custom-table tbody tr td {
    padding-top: 20px;
    /* Adjust the value as needed */
    padding-bottom: 20px;
    /* Adjust the value as needed */
}

.my-custom-table th {
    padding-bottom: 20px;
}

.my-custom-table th,
.my-custom-table td {
    text-align: left;
    /* Aligns text to the left */
    padding-left: 20px;
    padding-right: 20px;
}

.campName {
    text-decoration: none;
    color: inherit;
}

.campName:hover {
    color: rgb(10, 159, 92);
    cursor: pointer;
    text-decoration: none;
}

.iconsRow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.theActionIcon {
    font-weight: bolder;
    font-size: 18px;
    color: rgb(5, 2, 2);
    cursor: pointer;
}

.theActionIcon:hover {
    cursor: pointer;
    color: rgb(30, 158, 30);
    scale: 1.3;
    transition: 1s;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    /* Semi-transparent black background */
    display: flex;
    justify-content: center;
    /* Center horizontally */
    align-items: center;
    /* Center vertically */
    z-index: 999;
    /* Ensure the modal is on top */
}

/* Styles for the modal box */
.modal-box {
    background-color: white;
    width: 1100px;
    padding: 20px;
    border-radius: 2px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-content {
    text-align: center;
}

.model-box-header {
    display: flex;
    justify-content: space-between;
    /* background-color: antiquewhite; */
    height: 40px;
    margin-bottom: 15px;
}

.form-control {
    background-color: rgb(243, 246, 246);
}

.createBTN {
    width: 100%;
    margin-top: 20px;
}

.noTeamBox {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
    width: 100%;
}

.noMatchBox {
    background-color: red;
    width: 100%;
}

.loadMoreBtn {
    background-color: black;
    border-radius: 10px;
}

.button-13 {
    background-color: #fff;
    border: 1px solid #d5d9d9;
    border-radius: 8px;
    box-shadow: rgba(213, 217, 217, 0.5) 0 2px 5px 0;
    box-sizing: border-box;
    color: #0f1111;
    cursor: pointer;
    display: inline-block;
    font-family: "Amazon Ember", sans-serif;
    font-size: 13px;
    line-height: 29px;
    padding: 0 10px 0 11px;
    position: relative;
    text-align: center;
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    vertical-align: middle;
    min-width: 100px;
}

.button-13:hover {
    background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
}

.methodType {
    font-size: 13px;
    font-weight: normal;
    margin-left: 12px;
}

.theImgWrapper {
    width: 70px;
    height: 50px;
    overflow: hidden;
    /* box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px; */
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    border-radius: 5px;
    cursor: pointer;
}

.imgSignature {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 5px;

}

.theSheetImgBox {
    width: 100%;
    height: 600px;
    /* background-color: green; */
    overflow-y: auto;
    padding: 20px;
    background-color: rgb(235, 235, 235);
    border-radius: 10px;
}

.theSheetImg {
    width: 400px;
    border-radius: 10px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
</style>